import triggerChangeEvent from 'DOM/triggerChangeEvent';

const handleSubtractQuantity = (item, e) => {
  e.preventDefault();
  const input = item.querySelector("input[type=number].quantity");
  const current_value = input.value;
  if(current_value > 1){
    input.value = parseInt(input.value) - 1;
    triggerChangeEvent(input);
  }
}

export default handleSubtractQuantity;
